export default{
  user: state => state.user,
  status: state => state.user.status,
  popup: state => state.showPhonePopup,
  showedPopup: state => state.showedPopup,
}